import React from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';

const DEEP_GREEN = '#027F5D';
const PALE_MINT = '#D7F7E9';
const CHARCOAL = '#434343';

const formatMoney = (amount: number) => `$${amount.toFixed(2)}`;

const pillStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  background: PALE_MINT,
  color: DEEP_GREEN,
  borderRadius: 999,
  padding: '8px 24px',
  fontWeight: 'bold',
  maxWidth: '100%'
};

interface IPromoBannerProps {
  label: string;
  percent: number;
}

/** pill shown under the page heading so the promo reads as a benefit */
export const PromoBanner = ({ label, percent }: IPromoBannerProps) => (
  <Box style={{ marginTop: 16 }}>
    <Typography component="div" style={{ ...pillStyle, fontSize: 16 }}>
      <LocalOfferOutlinedIcon fontSize="small" style={{ marginRight: 8 }} />
      {label}: {percent}% off the Yearly Plan
    </Typography>
  </Box>
);

interface IRowProps {
  label: string;
  value: string;
  marginBottom: number;
  textStyle: React.CSSProperties;
}

const Row = ({ label, value, marginBottom, textStyle }: IRowProps) => (
  <Grid
    item
    xs={12}
    style={{ display: 'flex', justifyContent: 'space-between', marginBottom }}
  >
    <Typography variant="body2" style={textStyle}>
      {label}
    </Typography>
    <Typography
      variant="body2"
      style={{ ...textStyle, marginLeft: 16, whiteSpace: 'nowrap' }}
    >
      {value}
    </Typography>
  </Grid>
);

interface IPromoDiscountRowsProps {
  label: string;
  percent: number;
  subtotal: number;
  discount: number;
}

/** subtotal and discount lines, shown above the (hero) total */
export const PromoDiscountRows = ({
  label,
  percent,
  subtotal,
  discount
}: IPromoDiscountRowsProps) => (
  <>
    <Row
      label="Subtotal:"
      value={formatMoney(subtotal)}
      marginBottom={8}
      textStyle={{ fontSize: 16, color: CHARCOAL }}
    />
    <Row
      label={`${label} (${percent}% off)`}
      value={`-${formatMoney(discount)}`}
      marginBottom={16}
      textStyle={{ fontSize: 14, fontWeight: 'bold', color: DEEP_GREEN }}
    />
  </>
);

/** shown right under the total */
export const PromoSavingsPill = ({ discount }: { discount: number }) => (
  <Grid
    item
    xs={12}
    style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}
  >
    <Typography
      component="div"
      style={{ ...pillStyle, padding: '4px 16px', fontSize: 14 }}
    >
      You save {formatMoney(discount)}
    </Typography>
  </Grid>
);
